module.exports = __webpack_public_path__ + "img/25.4a1a6374.jpg";